import {lazy} from 'react'

export const ElaArticleDebuggerHandler = lazy(() => import('./../../../../ela/debugger/components'))

export const ElaOverviewHandler = lazy(
  () => import('./../../../../ela/common/components/content-overview'),
)

export const StandardsPageHandler = lazy(
  () => import('./../../../../ela/standards/components/standard-page'),
)
